import React from "react";
import Grid from "@material-ui/core/Grid";
import { Field } from "react-final-form";
import {
  bodymetrixAvaliacaoApi,
  bodymetrixRegiaoAvaliacaoApi,
  bodymetrixRegiaoApi,
  clienteApi,
} from "../../services/Api";
import {
  List,
  MountEntity,
  CrudForm,
  useParentChildrenNavigation,
  CrudTabs,
  CrudRoute,
  ListApi,
  FormApi,
  DatePicker,
  Autocomplete,
  loopback,
  Filter,
  autocompleteHelpers,
} from "elentari";
import moment from "moment";
import { path } from "ramda";
import ImagePicker from "../../components/ImagePicker";
import { getUTCFormatedDate } from "../../utils/dateParse";

const { loopbackFilters } = loopback;

function BodymetrixAvaliacaoFilter(props) {
  return (
    <Filter
      formatFilters={{ clienteId: (value) => value.id }}
      labels={{ find: "Buscar", clear: "Limpar" }}
    >
      <Grid spacing={24} container>
        <Grid item xs>
          <Field
            label="Cliente"
            loadOptions={loadClientes}
            component={Autocomplete}
            name="clienteId"
          />
        </Grid>
      </Grid>
    </Filter>
  );
}

export function BodymetrixAvaliacaoList(props) {
  const listOptions = {
    defaultOrder: "dataCadastro desc",
    fields: {
      cliente: {
        label: "Cliente",
      },
      dataCadastro: {
        label: "Data",
        format: (date) =>
          date ? moment(getUTCFormatedDate(date)).format("DD/MM/YYYY") : "",
      },
    },
  };

  const getPageDecorator = async ({ getPage }) => {
    const items = await getPage();
    if (!items) return;
    const promises = items.map(async (item) => {
      const response = await clienteApi.getOne(item.clienteId);
      if (response.ok) {
        return {
          ...item,
          cliente: response.data.nome,
          clienteId: undefined,
        };
      }
      return item;
    });
    return Promise.all(promises);
  };

  return (
    <ListApi getPageDecorator={getPageDecorator} api={bodymetrixAvaliacaoApi}>
      {({ getPage, getCount, handleDelete }) => (
        <div>
          <BodymetrixAvaliacaoFilter />
          <List
            {...props}
            withPaper
            labelNew="Novo"
            deleteItem={handleDelete}
            onClickEdit={(item) =>
              props.history.push(`/bodymetrix-avaliacao/${item.id}`)
            }
            onClickNew={() => props.history.push("/bodymetrix-avaliacao/new")}
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </div>
      )}
    </ListApi>
  );
}

export function BodymetrixAvaliacaoForm(props) {
  const validate = (values) => ({
    cliente: values.cliente ? undefined : "Obrigatório",
  });

  const submitDecorator = async ({ data, id, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        cliente: undefined,
        clienteId: data.cliente.id,
      },
    });
    return result;
  };

  const getItem = async () => {
    return MountEntity(props, bodymetrixAvaliacaoApi.getOne)
      .populate(({ data, id }) => ({
        cliente: clienteApi.getOne(data.clienteId),
      }))
      .clean(["clienteId"])
      .map((data) => ({
        ...data,
        cliente: autocompleteHelpers.toOption("nome")(data.cliente),
        dataCadastro: getUTCFormatedDate(data.dataCadastro),
      }))
      .getItem();
  };

  return (
    <FormApi
      api={bodymetrixAvaliacaoApi}
      submitDecorator={submitDecorator}
      {...props}
    >
      {({ handleSubmit }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item xs>
                  <Field
                    label="Cliente"
                    loadOptions={loadClientes}
                    component={Autocomplete}
                    name="cliente"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    component={DatePicker}
                    label="Data Avaliação"
                    name="dataCadastro"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}

const loadClientes = async (inputValue) => {
  const response = await clienteApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(autocompleteHelpers.toOption("nome"));
  }
  return [];
};

const loadRegiao = async (inputValue) => {
  const response = await bodymetrixRegiaoApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(autocompleteHelpers.toOption("nome"));
  }
  return [];
};

export function BodymetrixRegiaoAvaliacaoForm(props) {
  const validate = (values) => ({
    image: values.image ? undefined : "Obrigatório",
    regiao: values.regiao ? undefined : "Obrigatório",
  });

  const getItem = async () => {
    return MountEntity(props, bodymetrixRegiaoAvaliacaoApi.getOne)
      .populate(({ data, id }) => ({
        regiao: bodymetrixRegiaoApi.getOne(data.bodymetrixRegiaoId),
      }))
      .clean(["bodymetrixRegiaoAvaliacaoId"])
      .map((data) => ({
        ...data,
        regiao: autocompleteHelpers.toOption("nome")(data.regiao),
      }))
      .getItem();
  };

  const submitDecorator = async ({ data, id, handleSubmit }) => {
    const isNewImage = (image) => Array.isArray(image);
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        image: isNewImage(data.image) ? undefined : data.image,
        regiao: undefined,
        bodymetrixRegiaoId: data.regiao.id,
        bodymetrixAvaliacaoId: +props.match.params.id,
      },
    });
    if (result.ok && isNewImage(data.image)) {
      const formData = new FormData();
      formData.append("image", data.image[0].file);
      await bodymetrixRegiaoAvaliacaoApi.uploadImage(
        path(["data", "id"], result) || id,
        formData
      );
    }
    setTimeout(() => props.history.goBack(), 500);
    return result;
  };

  return (
    <FormApi
      submitDecorator={submitDecorator}
      api={bodymetrixRegiaoAvaliacaoApi}
      {...props}
    >
      {({ handleSubmit }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item xs>
                  <Field
                    label="Região"
                    loadOptions={loadRegiao}
                    component={Autocomplete}
                    name="regiao"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    width={300}
                    height={300}
                    defaultImage={require("../../images/empty-image.png")}
                    component={ImagePicker}
                    label="Imagem"
                    name="image"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}

function BodymetrixRegiaoAvaliacaoList(props) {
  const listOptions = {
    defaultOrder: "regiao",
    fields: {
      image: {
        label: "Imagem",
        format: (url) => (
          <img alt="Miniatura Bodymetrix" src={url} height="75" width="75" />
        ),
      },
      regiao: {
        label: "Região",
      },
    },
  };

  const getPageDecorator = async () => {
    const items = await bodymetrixRegiaoAvaliacaoApi.getList({
      where: {
        bodymetrixAvaliacaoId: props.match.params.id,
      },
    });
    const promises = items.data.map(async (item) => {
      const response = await bodymetrixRegiaoApi.getOne(
        item.bodymetrixRegiaoId
      );
      if (response.ok) {
        item.regiao = response.data.nome;
        item.bodymetrixRegiaoId = undefined;
        return item;
      }
      return item;
    });
    return Promise.all(promises);
  };

  return (
    <ListApi
      api={bodymetrixRegiaoAvaliacaoApi}
      getPageDecorator={getPageDecorator}
    >
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          deleteItem={handleDelete}
          labelNew="Novo"
          onClickEdit={(item) =>
            props.history.push(`${props.location.pathname}/${item.id}`)
          }
          onClickNew={props.onClickNew}
          getCount={getCount}
          getPage={getPage}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function BodymetrixAvaliacaoTabs(props) {
  const { current, navigate } = useParentChildrenNavigation(props, {
    mainPath: "bodymetrix-avaliacao",
    availableTabs: ["cadastrar-regiao"],
  });
  return (
    <CrudTabs
      {...props}
      mainPath="bodymetrix-avaliacao"
      current={current}
      tabs={[
        { value: "", label: "Avaliação" },
        { value: "cadastrar-regiao", label: "Regiões" },
      ]}
      navigate={navigate}
    >
      <div>
        <CrudRoute render={() => <BodymetrixAvaliacaoForm {...props} />} />
        <CrudRoute
          name="cadastrar-regiao"
          render={(props) => (
            <BodymetrixRegiaoAvaliacaoList
              onClickNew={navigate("newChild")}
              {...props}
            />
          )}
        />
        <CrudRoute
          name="cadastrar-regiao"
          isForm
          render={(props) => <BodymetrixRegiaoAvaliacaoForm {...props} />}
        />
      </div>
    </CrudTabs>
  );
}
